// extracted by mini-css-extract-plugin
module.exports = {"approval":"Approval_approval__3SbVN","infoBlock":"Approval_infoBlock__1aeRN","answerBtnWrap":"Approval_answerBtnWrap__1irlD","answerBtn":"Approval_answerBtn__1Qc9W"};